module.exports = __webpack_public_path__ + "static/media/TransactionVertical.e87d440a.png";